<template>
  <div class="calendar">
    <!-- Month Navigation -->
    <div class="month">
      <a href="#" class="nav" @click.prevent="changeMonth(-1)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"/>
        </svg>
      </a>
      <div>{{ monthName }} <span class="year">{{ year }}</span></div>
      <a href="#" class="nav" @click.prevent="changeMonth(1)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="black" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"/>
        </svg>
      </a>
    </div>

    <!-- Days of the Week -->
    <div class="days">
      <span>Lun</span>
      <span>Mar</span>
      <span>Mer</span>
      <span>Jeu</span>
      <span>Ven</span>
      <span>Sam</span>
      <span>Dim</span>
    </div>

    <!-- Calendar Dates -->
    <div class="dates">
      <button :style="index === 0 ? { '--start-day': startOfMonth } : {}" :class="{'has-freetime': has_freetime(year,month,day), 'is-selected': day == selected_day}" 
              v-for="(day, index) in daysInMonth" :key="day" @click="select_date(year,month,day)">
        <time>{{ day }}</time>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

// console.log(moment(), moment().format('MM'), moment("2025" + "-" + "06" + "-01").format('e'))
// function gridColumn(year, month) {
//       let x = 0
//       x = parseInt(moment(year + "-" + month + "-01").format('e'))
//       return x === 0 ? 7 : x
// }
function gridColumn(year, month) {
  if (!year || !month) return 1; // Valeur par défaut
  const dateStr = `${year}-${String(month).padStart(2, '0')}-01`;
  const m = moment(dateStr, "YYYY-MM-DD", true);
  if (!m.isValid()) return 1;
  const x = parseInt(m.format('e'));
  return x === 0 ? 7 : x;
}
export default {
  name: 'DatePicker',
  props: {
    free_days: {},
    first_date: null,
    config: {},
    can_select_number: null
  },
  emits: ['selected','monthChanged'],
  data() {
    
    return {
      month: parseInt(moment().format('MM')), // January
      year:  parseInt(moment().format('YYYY')),
      startOfMonth: gridColumn(this.year, this.month),
      selected_day: null,
    };
  },
  computed: {
    get_free_days(){
      // console.log("datepicker get_free_days",Object.keys(this.free_days));
      return this.free_days;
    },
    // Compute the month name (January, February, etc.)
    monthName() {
      const months = [
        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
        'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
      ];
      return months[this.month - 1];
    },
    // Calculate the number of days in the current month
    daysInMonth() {
      // Adjust for leap year in February
      const daysInMonthMap = {
        0: 0,
        1: 31, // January
        2: (this.isLeapYear() && this.year % 4 === 0) ? 29 : 28, // February
        3: 31, // March
        4: 30, // April
        5: 31, // May
        6: 30, // June
        7: 31, // July
        8: 31, // August
        9: 30, // September
        10: 31, // October
        11: 30, // November
        12: 31 // December
      };

      // Get the number of days in the current month
      const days = daysInMonthMap[this.month];

      // Create an array of days for the current month
      return Array.from({ length: days }, (_, index) => index + 1);
    }
  },
  methods: {
    // Change month by clicking left or right arrow
    
    changeMonth(direction) {
      this.month += direction;
      // Handle year change when going from December to January or vice versa
      if (this.month > 12) {
        this.month = 1;
        this.year++;
      } else if (this.month < 1) {
        this.month = 12;
        this.year--;
      }
      this.startOfMonth = gridColumn(this.year, this.month)
      this.$emit('monthChanged',this.year+"-"+this.month);
    },
    // Check if the current year is a leap year
    isLeapYear() {
      return (this.year % 4 === 0 && this.year % 100 !== 0) || (this.year % 400 === 0);
    },
    format_date(year,month,day){
      return year+'-'+(month.toLocaleString('fr-FR',{minimumIntegerDigits:2,useGrouping:false}))+'-'+(day.toLocaleString('fr-FR',{minimumIntegerDigits:2,useGrouping:false}));
    },
    select_date(year,month,day){
      if(this.has_freetime(year,month,day)){
        this.selected_day = day;
        this.$emit('selected',this.format_date(year,month,day));
      }
    },
    set_month_year(date) {
      if (!date || typeof date !== 'string' || !date.includes('-')) return;
      const newDate = date.split("-");
      const y = parseInt(newDate[0]);
      const m = parseInt(newDate[1]);
      if (!y || !m) return;
      this.year = y;
      this.month = m;
      this.startOfMonth = gridColumn(this.year, this.month)
    },
    has_freetime(year,month,day){
      if(!(this.format_date(year,month,day) in this.get_free_days)){
        // console.log("DatePicker has_freetime 1",this.format_date(year,month,day));
        
        return false;
      }
      if(this.config['MULTIPLE_RDV'] == 1 && this.config['MULTIPLE_RDV_SLOT_IMPOSITION'] == 1 && !this.imposition_day_match(this.free_days[this.format_date(year,month,day)]?.free_times)){
        // console.log("DatePicker has_freetime 2",this.format_date(year,month,day),this.free_days[this.format_date(year,month,day)]);
        return false;
      }
      return true;
    },
    imposition_day_match(day_freetimes){
        let filtered_freetimes = this.config['SLOT_IMPOSITION_TIME_SECTION'] == 'MORNING' ? this.day_section_free_times(false, this.config['SLOT_IMPOSITION_MORNING_MAX'], day_freetimes) : this.config['SLOT_IMPOSITION_TIME_SECTION'] == 'AFTERNOON' ? this.day_section_free_times(true, this.config['SLOT_IMPOSITION_AFTERNOON_MIN'], day_freetimes) : day_freetimes;
        if(this.can_select_number < this.config['SLOT_IMPOSITION_FROM']){
            // console.log('imposition_day_match 1');
            return true;
        }else if(this.config['SLOT_IMPOSITION_FROM'] > filtered_freetimes?.length){
          // console.log('imposition_day_match 2',day_freetimes,this.free_days);
            return false;
        }else{
          // console.log('imposition_day_match 3',day_freetimes,this.free_days);
            return true;
        }
    },
    day_section_free_times(is_min, section_limit, day_freetimes){
      // console.log('DatePicker day_section_free_times', day_freetimes);
      let filtered_freetimes = is_min ? day_freetimes?.filter(free_time => section_limit <= moment(free_time.start).format("HH:mm:ss")) : day_freetimes?.filter(free_time => section_limit >= moment(free_time.start).format("HH:mm:ss"));
      return filtered_freetimes;
    }
  },
  created() {
    this.changeMonth(0)
  },

  mounted() {
    if (this.first_date) {
      this.set_month_year(this.first_date);
    } else {
      // Si aucune date initiale, utiliser la date actuelle
      this.year = parseInt(moment().format('YYYY'));
      this.month = parseInt(moment().format('MM'));
      this.startOfMonth = gridColumn(this.year, this.month);
    }
    // this.set_month_year(this.first_date)    
  },
};
</script>

<style scoped>
    .day-btn {
        width: 48px;
        height: 48px;
    }
    
    .calendar {
        height: 25rem;
        justify-content: center;
        align-items: center;
        background: #fff;
        padding: 20px;
        border-radius: 5px;
    }

    .calendar .month {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        font-weight: 300;
    }

    .calendar .month .year {
        font-weight: 600;
        margin-left: 10px;
    }

    .calendar .month .nav {
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        color: #0a3d62;
        width: 40px;
        height: 40px;
        border-radius: 40px;
        transition-duration: 0.2s;
        position: relative;
    }

    .calendar .month .nav:hover {
        background: #eee;
    }

    .calendar .days {
        display: grid;
        justify-content: center;
        align-items: center;
        grid-template-columns: repeat(7, 1fr);
        color: #999;
        padding: 0px 8px;
        font-weight: 600;
        margin-top: 12px;
        margin-bottom: 12px;
    }

    .calendar .days span {
        width: 45px;
        justify-self: center;
        align-self: center;
        text-align: center;
    }

    .calendar .dates {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 2px;
    }

    .calendar .dates button {
        cursor: pointer;
        outline: 0;
        border: 0;
        background: transparent;
        font-size: 16px;
        justify-self: center;
        align-self: center;
        width: 30px;
        height: 30px;
        border-radius: 50px;
        margin: 2px;
        transition-duration: 0.2s;
    }

    /* IMPORTANT: Utiliser la variable CSS au lieu d'une valeur fixe */
    .calendar .dates button:first-child {
        grid-column-start: var(--start-day, 1);
    }

    .has-freetime{
      color: var(--primary-color);
      background-color: rgba(39, 28, 73, 0.07) !important;
    }

    .is-selected{
      color: #fff;
      background-color: var(--primary-color) !important;
    }

    .calendar .dates button.today {
        box-shadow: inset 0px 0px 0px 2px #0a3d62;
    }

    .calendar .dates button:hover {
        background: #eee;
    }

    @media (min-width: 1400px) {

      .calendar {
        height: 30rem !important;
      }

      .calendar .days{
          gap: 18px;
      }

      .calendar .dates{
          gap: 15px 11px;
      }

      .calendar .dates button{
          width: 50px;
          height: 50px;
      }
    }

    @media (min-width: 1300px) and (max-width: 1400px) {
      .calendar .dates button {
        width: 40px;
        height: 40px;
      }
    }

    @media (max-width: 1400px) {
      .calendar .dates{
        gap: 25px 0px;
      }
    }

    @media (max-width: 1199px) {
      .calendar{
        padding-left: 0px;
        padding-right: 0px;
      }
    }

    /* Pour mobile - styles spécifiques */
    @media (max-width: 768px) {
      .calendar {
        padding: 10px;
      }
      
      .calendar .days span {
        font-size: 12px;
        width: auto;
        padding: 4px 8px;
      }
      
      .calendar .dates button {
        font-size: 12px;
        width: 35px;
        height: 35px;
        margin: 1px;
      }
    }

    @media (max-width: 480px) {
      .calendar .dates button {
        width: 30px;
        height: 30px;
        font-size: 11px;
      }
      
      .calendar .days span {
        font-size: 11px;
      }
    }
</style>